export const getDimensions = widget => {
  const widgetOffsetY = widget.node.getBoundingClientRect().top + window.scrollY
  const widgetHeight = widget.node.getBoundingClientRect().height
  const viewOffsetY = window.scrollY
  const viewHeight = window.innerHeight
  return { widgetOffsetY, widgetHeight, viewOffsetY, viewHeight }
}

export const isHalfViewFilledByWidget = widget => {
  const { widgetOffsetY, widgetHeight, viewOffsetY, viewHeight } = getDimensions(widget)
  const topWidgetIsFillingBottomHalfView = viewOffsetY + viewHeight / 2 >= widgetOffsetY
  const bottomWidgetIsFillingTopHalfView = viewOffsetY + viewHeight / 2 <= widgetOffsetY + widgetHeight

  return topWidgetIsFillingBottomHalfView && bottomWidgetIsFillingTopHalfView
}

export const isHalfWidgetVisible = widget => {
  const { widgetOffsetY, widgetHeight, viewOffsetY, viewHeight } = getDimensions(widget)
  const viewBottomIsBelowTopHalfWidget = viewOffsetY + viewHeight >= widgetOffsetY + widgetHeight / 2
  const viewTopIsAboveBottomHalfWidget = viewOffsetY <= widgetOffsetY + widgetHeight / 2

  return viewBottomIsBelowTopHalfWidget && viewTopIsAboveBottomHalfWidget
}

export default widget => {
  const isWidgetHidden = widget.node.offsetParent === null // if one of the parents is display none, this will be null.
  const isWidgetFixed = widget.node.style.position === 'fixed' // position fixed has no offsetParent

  if (isWidgetHidden && !isWidgetFixed) {
    return false
  }

  return isHalfViewFilledByWidget(widget) || isHalfWidgetVisible(widget)
}
